import { TextAreaTemplate } from '@templates';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { RoutesList } from '../../../../routes/Routes';
import { useDrainsStore } from '../../../../hooks/useDrainsStore';
import { ErrorMessages } from '@types';
import { parseZodErrors, scrollTop } from '@utils';
import { ZodError } from 'zod';
import { MAX_LENGTH } from '@shared/constants';
import {
  BLOCKED_DRAIN,
  FLOODING,
  SMELLY_DRAIN,
  SOMETHING_ELSE,
} from '../../../../constants/drains';

export const DescribeTheIssue = () => {
  const {
    update,
    data: { issueType, tellUsMoreDetails },
  } = useDrainsStore();
  const [textInput, setTextInput] = useState(tellUsMoreDetails);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();
  const pageTitle = 'Describe the issue';
  const description =
    "Tell us more about the issue you're reporting, for example, what's blocking the drain.";
  const errorPath = 'tellUsMore';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextInput(event.target.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      setErrorMessages([]);
      try {
        if (textInput === '') {
          setErrorMessages([
            {
              path: errorPath,
              message: 'Enter details about the issue.',
            },
          ]);
          return;
        }
        if (textInput.length > MAX_LENGTH) {
          setErrorMessages([
            {
              path: errorPath,
              message:
                'Details about the issue must be 500 characters or less.',
            },
          ]);
          return;
        }

        update('tellUsMoreDetails', textInput);
        navigate(RoutesList.UPLOAD_PHOTOS);
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const handleNavigate = () => {
    switch (issueType) {
      case BLOCKED_DRAIN:
        navigate(RoutesList.PRIVATE_PROPERTY_ISSUE);
        break;
      case FLOODING:
        navigate(RoutesList.FLOOD_AFFECTING);
        break;
      case SMELLY_DRAIN:
        navigate(RoutesList.PRIVATE_PROPERTY_ISSUE);
        break;
      case SOMETHING_ELSE:
        navigate(RoutesList.PRIVATE_PROPERTY_ISSUE);
        break;
      default:
        return;
    }
  };

  const buttonPrevious = {
    onClick: () => {
      handleNavigate();
      scrollTop();
    },
  };

  return (
    <TextAreaTemplate
      initialTextValue={textInput}
      labelText={pageTitle}
      description={description}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={MAX_LENGTH}
      errorPath={errorPath}
      errorMessages={errorMessages}
    />
  );
};
